"use client";
import Image from "next/image";
import React, { useState } from "react";

const JoinTeam: React.FC = () => {
    const [formData, setFormData] = React.useState({
        prenom: '',
        nom: '',
        trainingSector: '',
        email: '',
        phoneCode: '+33',
        phone: '',
    });
    const [cvFile, setCvFile] = useState<File | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0] ?? null;
        setCvFile(file);
    };

    const isFormValid = Object.values(formData).every(value => value.trim() !== '');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (isFormValid) {
            console.log('Form submitted:', { ...formData, cvFile });
        }
    };


    return (
        <section className="w-full bg-[#1B515E] text-white pt-12.5 pb-14.25 px-4 relative">
            <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 -translate-x-1/2 -top-5">
                <Image src='/assets/small-logo.svg' alt='small-logo' title='small-logo' width={30} height={17} />
            </div>

            <h2 className="font-red-hat text-white text-[30px] md:text-[40px] leading-10 md:leading-13.25 font-light max-w-150 mx-auto text-center">
                Vous souhaitez devenir mentor chez Spot Formations ?
            </h2>

            <div className="max-w-258.25 w-full mx-auto flex md:flex-row flex-col items-start text-left justify-between gap-8 md:gap-6 md:mt-17.75 mt-10">
                <div className="max-w-116.75 w-full md:text-left text-center">
                    <h3 className="text-white text-[15px] md:text-[20px] leading-4.5 md:leading-7.5 tracking-[0.01rem] font-bold md:font-normal">Créez votre <span className="font-bold">dossier de candidature</span> et rejoignez l’équipe Spot Formations.</h3>
                    <ul className="mt-8 md:mt-11 flex items-start justify-center flex-col mx-auto w-full space-y-5.75">
                        <li className="flex items-center gap-3.25">
                            <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#FC7F16] border border-white"></div>
                            <h3 className="text-white text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">Une équipe engagée en accord avec nos missions</h3>
                        </li>
                        <li className="flex items-center gap-3.25">
                            <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#FC7F16] border border-white"></div>
                            <h3 className="text-white text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">Construisez votre parcours de formateur</h3>
                        </li>
                        <li className="flex items-center gap-3.25">
                            <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#FC7F16] border border-white"></div>
                            <h3 className="text-white text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">Augmentez vos performances</h3>
                        </li>
                        <li className="flex items-center gap-3.25">
                            <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#FC7F16] border border-white"></div>
                            <h3 className="text-white text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">Profitez de nos avantages Marketing</h3>
                        </li>
                    </ul>
                </div>

                <div className="max-w-109.75 w-full">
                    <h3 className="text-white text-[15px] sm:text-[20px] leading-4.5 sm:leading-7.5 font-medium tracking-[0.4px]">Démarrez votre nouvelle trajectoire chez nous:</h3>
                    <form onSubmit={handleSubmit} className="mt-4.5 sm:mt-5">
                        <div className="mb-4 md:mb-7.25">
                            <input
                                type="text"
                                name="prenom"
                                placeholder="Prénom"
                                value={formData.prenom}
                                onChange={handleChange}
                                className="w-full h-10 px-3 rounded-lg border border-[#EFEFEF] bg-white placeholder:text-[#ABABAB] text-[12px] font-normal text-[#1D1D1D] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE]"
                            />
                        </div>
                        <div className="mb-4 md:mb-7.25">
                            <input
                                type="text"
                                name="nom"
                                placeholder="Nom"
                                value={formData.nom}
                                onChange={handleChange}
                                className="w-full h-10 px-3 rounded-lg border border-[#EFEFEF] bg-white placeholder:text-[#ABABAB] text-[12px] font-normal text-[#1D1D1D] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE]"
                            />
                        </div>
                        <div className="mb-4 md:mb-7.25">
                            <input
                                type="text"
                                name="trainingSector"
                                placeholder="Secteur de formation"
                                value={formData.trainingSector}
                                onChange={handleChange}
                                className="w-full h-10 px-3 rounded-lg border border-[#EFEFEF] bg-white placeholder:text-[#ABABAB] text-[12px] font-normal text-[#1D1D1D] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE]"
                            />
                        </div>
                        <div className="mb-4 md:mb-7.25">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full h-10 px-3 rounded-lg border border-[#EFEFEF] bg-white placeholder:text-[#ABABAB] text-[12px] font-normal text-[#1D1D1D] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE]"
                            />
                        </div>
                        <div className="mb-4 md:mb-7.25">
                            <input
                                id="cv-upload"
                                type="file"
                                accept=".doc,.docx,.pdf,.rtf,.txt"
                                onChange={handleFileChange}
                                className="hidden"
                            />
                            <label
                                htmlFor="cv-upload"
                                className={`
                                    relative w-full h-10 px-4 sm:px-5
                                    rounded-lg border border-[#EFEFEF] bg-white
                                    flex items-center justify-between
                                    cursor-pointer group
                                `}
                            >
                                <div className={`${cvFile ? "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" : "sm:absolute sm:left-1/2 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2"} flex items-center gap-2.5 min-w-0 transition-transform`}>
                                    <Image src="/assets/icons/paperclip.svg" alt="Attach" width={14} height={16} className="shrink-0" />
                                    <span
                                        className={`text-[13px] truncate max-w-60 sm:max-w-[320px]
                                        ${cvFile ? 'text-[#1D1D1D] font-medium' : 'text-[#ABABAB]'}
                                    `}
                                    >
                                        {cvFile ? cvFile.name : 'CV'}
                                    </span>
                                </div>

                                <span className={` ${cvFile && "hidden"} sm:absolute right-3 top-1/2 transition-transform sm:-translate-y-1/2 text-[#9CA3AF] text-[12px] whitespace-nowrap`}>
                                    .doc .docx .pdf .rtf .txt
                                </span>
                            </label>
                        </div>
                        <div className="flex gap-2.5 sm:gap-4.5">
                            <input
                                type="tel"
                                name="phoneCode"
                                placeholder="+33"
                                value={formData.phoneCode}
                                onChange={handleChange}
                                maxLength={4}
                                className="w-14 h-10 px-3 text-center rounded-lg border border-[#EFEFEF] bg-white placeholder:text-[#ABABAB] text-[12px] font-normal text-[#1D1D1D] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE]"
                            />
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Portable"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full h-10 px-3 rounded-lg border border-[#EFEFEF] bg-white placeholder:text-[#ABABAB] text-[12px] font-normal text-[#1D1D1D] focus:outline-none focus:border-[#40BFDE] focus:ring-1 focus:ring-[#40BFDE]"
                            />
                        </div>

                        <div className="text-[12px] text-white leading-5 mb-8.75 mt-7.25 font-medium tracking-[0.25px]">
                            *Tous les champs sont obligatoires
                        </div>

                        <button
                            type="submit"
                            className={`w-full h-12 sm:h-14.5 border font-bold text-[16px] rounded-lg transition-all duration-300 ${isFormValid
                                ? "bg-[#152b4d] text-white border-[#152b4d] hover:bg-[#152b4dd3] cursor-pointer"
                                : "bg-[#D9D9D9] border-[#ABABAB] text-[#ABABAB] cursor-not-allowed"
                                }`}
                            disabled={!isFormValid}
                        >
                            Envoyer ma candidature
                        </button>
                    </form>
                </div>
            </div>

        </section>
    );
}


export default JoinTeam